import React from 'react';
import Select from 'react-select';
import SimpleBar from 'simplebar-react';

const CustomMenu = props => {
  return (
    <SimpleBar className="react-select__menu-component" autoHide={false}>
      {props.children}
    </SimpleBar>
  );
};

const SelectDropdown = props => {
  const { fieldLabel, isSuccess } = props;
  const disabledOptionStyle = {
    option: (styles, { isDisabled }) => ({
      ...styles,
      opacity: isDisabled ? 0.5 : 1,
      pointerEvents: isDisabled ? 'none' : 'auto'
    })
  };
  let statusClass = '';
  switch (isSuccess) {
    case true:
      statusClass = 'field-wrapper--success';
      break;

    case false:
      statusClass = 'field-wrapper--error';
      break;

    default:
      statusClass = '';
      break;
  }

  return (
    <div className={`field-wrapper ${statusClass}`}>
      {fieldLabel ? <label className="field__label">{fieldLabel}</label> : null}

      <Select
        autoFocus={false}
        captureMenuScroll={false}
        className="react-select"
        classNamePrefix="react-select"
        closeMenuOnSelect={true}
        hideSelectedOptions={true}
        isClearable={false}
        isMulti={false}
        isSearchable={true}
        menuPlacement="bottom"
        openMenuOnFocus={false}
        components={{
          MenuList: props => CustomMenu(props),
          IndicatorSeparator: () => null,
          DropdownIndicator: () => <span className="arrow" />
        }}
        styles={disabledOptionStyle}
        isOptionDisabled={option => option.disabled}
        {...props}
      />
    </div>
  );
};

export default SelectDropdown;
